import React, { useState, useEffect } from 'react';
import FilterGridComponent from "./../../modules/Shared/components/FilterGridComponent";
import axios from "./../../services/http";
import { Form, Input, Select, Col, Row } from 'antd';

const FiltrosBusqueda = ({ sendDataFilters }) => {

    const [form] = Form.useForm();
    const [obras, setObras] = useState([]);
    const [contratistas, setContratistas] = useState([]);

    const [expand, setExpand] = useState(false);

    const onFormValuesChange = async () => {
        const values = await form.validateFields();
        sendDataFilters(values);
    };

    const CleanFilters = async () => {
        form.resetFields();
        const values = await form.validateFields();
        sendDataFilters(values);
    }

    const GetCatalogWorks = async () => {
        try {
            const response = await axios.HTTP_GET("/api/v1/catalogs/works");
            setObras(response);
        } catch (error) {
            console.error('Error al obtener catálogo de obras:', error);
        } finally {}
    }

    const GetCatalogBuilders = async () => {
        try {
            const response = await axios.HTTP_GET("/api/v1/catalogs/builders");
            setContratistas(response);
        } catch (error) {
            console.error('Error al obtener catálogo de contratistas:', error);
        } finally {}
    }

    useEffect(() => {
        GetCatalogWorks();
        GetCatalogBuilders();
    }, []);

    return (
        <>
            <FilterGridComponent 
                formFilter={
                    <Form
                        layout="vertical"
                        variant={'filled'}
                        form={form}
                        onValuesChange={onFormValuesChange}
                    >
                        <Row gutter={[16, 16]} justify="space-between">
                            <Col xs={24} sm={24} md={12} lg={8}>
                                <Form.Item
                                    label="Obra"
                                    name="obra"
                                    style={{ width: "100%" }}
                                >
                                    <Select placeholder="Selecciona una obra" style={{ width: "100%" }}>
                                        {obras.map((cp) => (
                                        <Select.Option key={cp.id} value={cp.id}>
                                            {cp.nombre}
                                        </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={8}>
                                <Form.Item
                                    label="Contratista"
                                    name="contratista"
                                    style={{ width: "100%" }}
                                >
                                    <Select placeholder="Selecciona un contratista" style={{ width: "100%" }}>
                                        {contratistas.map((cp) => (
                                        <Select.Option key={cp.id} value={cp.id}>
                                            {cp.nombre}
                                        </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={8}>
                                <Form.Item
                                    label="Relación"
                                    name="relacion"
                                    style={{ width: "100%" }}
                                >
                                    <Input type="number" min={0} placeholder="Ingrese el núm. de relación" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                }
                onCleanFilters={() => CleanFilters()}
            />

            {/* <Layout>
                <Content>
                    <Card>
                        <h3 style={{marginTop:0}}>Filtros de búsqueda</h3>
                        <Divider style={{ margin: '10px 0' }} />
                        {expand ?
                        <Form
                            layout="vertical"
                            variant={'filled'}
                            form={form}
                            onFinish={handleSubmit}
                            onValuesChange={onFormValuesChange}
                        >
                            <Row gutter={[16, 16]} justify="space-between">
                                <Col xs={24} sm={24} md={12} lg={8}>
                                    <Form.Item
                                        label="Obra"
                                        name="obra"
                                        style={{ width: "100%" }}
                                    >
                                        <Select placeholder="Selecciona una obra" style={{ width: "100%" }}>
                                            {obras.map((cp) => (
                                            <Select.Option key={cp.id} value={cp.id}>
                                                {cp.nombre_obra}
                                            </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={8}>
                                    <Form.Item
                                        label="Contratista"
                                        name="contratista"
                                        style={{ width: "100%" }}
                                    >
                                        <Select placeholder="Selecciona un contratista" style={{ width: "100%" }}>
                                            {obras.map((cp) => (
                                            <Select.Option key={cp.id} value={cp.id}>
                                                {cp.nombre_obra}
                                            </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={8}>
                                    <Form.Item
                                        label="Relación"
                                        name="relacion"
                                        style={{ width: "100%" }}
                                    >
                                        <Input type="number" min={0} placeholder="Ingrese el núm. de relación" />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                        :null}

                        <div style={{ textAlign: 'right' }}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit">
                                    Search
                                </Button>
                            <Button
                                onClick={() => {
                                form.resetFields();
                                }}
                            >
                                Clear
                            </Button>
                            <a
                                style={{ fontSize: 12 }}
                                onClick={() => {
                                setExpand(!expand);
                                }}
                            >
                                <DownOutlined rotate={expand ? 180 : 0} /> Collapse
                            </a>
                            </Space>
                        </div>
                    </Card>
                </Content>
            </Layout>

            <Flex gap="middle" align="end" vertical>
                <Flex align={"flex-end"}>
                    <Button type="primary">Primary</Button>
                </Flex>
            </Flex> */}
        </>
    )
}

export default FiltrosBusqueda;